import React from 'react'
import SuperAgent from 'superagent'
import { object, string } from 'prop-types'
import DateHelper from '../../../../../_plugins/lib/dateHelper'

class CCMessages extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: false,
      messages: { }
    }
  }

  componentDidMount () {
    this.getCCMessages()
  }

  getCCMessages () {
    const { HXCMKey, ccTimes } = this.props
    let requestUrl = '//static1.holidayextras.com/datafeeds/soapi/prodlib?code='
    requestUrl += HXCMKey + (ccTimes ? ',' + ccTimes : '')
    requestUrl += '&noCache=1'
    SuperAgent.get(requestUrl).end(this.storeMessages)
  }

  storeMessages (err, res = { }) {
    if (err || !res.body) return
    if (res.body.product) {
      res.body.products = { }
      res.body.products[ res.body.product._prodcode ] = res.body.product
      delete res.body.product
    }
    if (!res.body.products) return
    this.setState({
      messages: res.body.products
    })
  }

  getCCTimes () {
    const { ccTimes } = this.props
    if (!ccTimes) return false
    const { messages = { } } = this.state
    if (!messages[ccTimes]) return false
    return this.replaceVariables(messages[ccTimes].message)
  }

  getData () {
    let { ccData } = this.props
    if (!ccData) return { }
    ccData.Queue = ccData.CallsInQueue
    ccData.OnCall = ccData.TotalAgents - ccData.FreeAgents
    return ccData
  }

  replaceVariables (textString) {
    const { GREATER_THAN, LESS_THAN } = this.props
    const data = this.getData()
    return textString
      .replace('[FreeAgents]', data.FreeAgents)
      .replace('[TotalAgents]', data.TotalAgents)
      .replace('[AgentsOnCall]', data.OnCall)
      .replace('[QueuedAgents]', data.Queue)
      .replace(GREATER_THAN, '')
      .replace(LESS_THAN, '')
      .replace("\\'", "'")
  }

  getCCMessage () {
    const { HXCMKey, GREATER_THAN, LESS_THAN } = this.props
    const { messages = { } } = this.state
    const data = this.getData()
    if (!HXCMKey || !messages[HXCMKey] || messages[HXCMKey].archived) return this.getCCTimes()
    if (!data.TotalAgents || data.TotalAgents <= 0) return this.getCCTimes()
    const prodlibMessages = messages[HXCMKey]
    let message = this.replaceVariables(prodlibMessages.default_message)
    if (data.OnCall >= data.TotalAgents || data.Queue > 0) {
      message = this.replaceVariables(prodlibMessages.message)
    }
    Object.keys(prodlibMessages.message_version).map(item => {
      const messageVersion = prodlibMessages.message_version[item]
      const value = parseInt(this.replaceVariables(item), 10)
      if (item.match(GREATER_THAN)) {
        if (data.Queue > value) message = messageVersion
      } else if (item.match(LESS_THAN)) {
        if (data.Queue < value) message = messageVersion
      } else if (data.Queue === value) message = messageVersion
      return item
    })
    return message
  }

  render () {
    const message = this.getCCMessage()
    if (!message) return null
    const date = new Date()
    const hours = date.getHours() || '00'
    const minutes = date.getMinutes() || '00'
    const time = DateHelper.pad(hours, 2) + ':' + DateHelper.pad(minutes, 2)
    const timeStamp = DateHelper.formatDateToDddMMyy(date) + ' ' + time
    if (timeStamp === ' ') return null
    return (
      <p>{ message }<span className='text-muted small hidden-xs'>Last updated: { timeStamp }</span></p>
    )
  }
}

CCMessages.propTypes = {
  ccData: object,
  HXCMKey: string.isRequired,
  ccTimes: string,
  GREATER_THAN: string,
  LESS_THAN: string
}

CCMessages.defaultProps = {
  ccData: { },
  GREATER_THAN: 'greater_than_',
  LESS_THAN: 'less_than_'
}

const HelperCCMessages = {
  initialData: {
    ccData: {
      allAgents: { },
      Airport: null,
      Insurance: null,
      mag: null,
      Helppoints: null,
      BackOffice: null,
      NewProducts: null
    }
  },

  getCCData (callBack) {
    const requestUrl = '//staticsg.holidayextras.com/ccData.json'
    SuperAgent.get(requestUrl).withCredentials().end((err, res = {}) => {
      this.ccDataResponse(err, res, callBack)
    })
  },

  ccDataResponse (err, res = { }, callBack = () => {}) {
    const data = (!err && res.body) ? res.body : { queues: false }
    if (!data.queues) data.queues = false
    setTimeout(this.getCCData, (1000 * 60)) // Do it again every minute
    callBack({
      ccData: {
        allAgents: data._all || { },
        Airport: data.queues[0] || { },
        Insurance: data.queues[1] || { },
        mag: data.queues[2] || { },
        Helppoints: data.queues[3] || { },
        BackOffice: data.queues[4] || { },
        NewProducts: data.queues[5] || { }
      }
    })
  }
}

export default {
  CCMessages,
  HelperCCMessages
}



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/contactCentre/ccMessages.jsx